import React from "react";

const BooksFooter = () => {
  return (
    <footer className="bg-[#0f2233] text-white">
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* <div className="grid md:grid-cols-3 items-center gap-8"> */}
        <div className="grid md:grid-cols-[140px_1fr_140px] items-center gap-8">
          {/* left */}
          <div className="flex justify-center md:justify-start">
            <img
              src="/my-book-cover-transparent.png"
              alt="Think Before You Think"
              className="w-20"
            />
          </div>

          {/* center */}
          <div className="text-center">
            <h2
              className="text-3xl mb-2"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Think before you think.
            </h2>

            <p
              className="text-sm text-gray-300 mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Understand your mind. Change your life.
            </p>

            {/* <div className="flex justify-center gap-4 flex-wrap">
              <a
                href="https://wwnorton.com/books/9781324075165"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold"
              >
                PRE-ORDER NOW
              </a>

              <a
                href="/books/extract"
                className="border border-white px-5 py-2 text-sm font-semibold"
              >
                READ AN EXTRACT
              </a>

              <a
                href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold"
              >
                UK EDITION
              </a>
            </div> */}

            {/* <div className="flex justify-center items-center gap-3 flex-wrap">
              <a
                href="https://wwnorton.com/books/9781324075165"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold whitespace-nowrap"
              >
                ORDER
              </a>

              <a
                href="/books/extract"
                className="border border-white px-5 py-2 text-sm font-semibold whitespace-nowrap"
              >
                READ AN EXTRACT
              </a>

              <a
                href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-5 py-2 text-sm font-semibold whitespace-nowrap"
              >
                UK EDITION
              </a>
            </div> */}

            <div className="flex justify-center items-center gap-2 flex-nowrap">
              <a
                href="https://wwnorton.com/books/9781324075165"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-3 md:px-5 py-2 text-[10px] sm:text-xs md:text-sm font-semibold whitespace-nowrap text-center"
              >
                ORDER
              </a>

              <a
                href="/books/extract"
                className="border border-white px-3 md:px-5 py-2 text-[10px] sm:text-xs md:text-sm font-semibold whitespace-nowrap text-center"
              >
                READ AN EXTRACT
              </a>

              <a
                href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#D4AF37] text-black px-3 md:px-5 py-2 text-[10px] sm:text-xs md:text-sm font-semibold whitespace-nowrap text-center"
              >
                UK EDITION
              </a>
            </div>
          </div>

          {/* right */}
          <div></div>
        </div>

        {/* bottom nav */}
        <div className="border-t border-white/20 mt-8 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
            {/* <div className="flex gap-6">
              <a href="/books">THE BOOK</a>
              <a href="/books/science">THE SCIENCE</a>
              <a href="/books/about">ABOUT ADRIAN</a>
              <a href="/books/news">NEWS</a>
              <a href="/books/contact">CONTACT</a>
              <a
                href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                target="_blank"
                rel="noopener noreferrer"
              >
                UK EDITION
              </a>
            </div> */}

            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
              <a href="/books" className="whitespace-nowrap">
                BOOK
              </a>

              <a href="/books/science" className="whitespace-nowrap">
                SCIENCE
              </a>

              <a href="/books/about" className="whitespace-nowrap">
                ABOUT
              </a>

              <a href="/books/news" className="whitespace-nowrap">
                NEWS
              </a>

              <a href="/books/contact" className="whitespace-nowrap">
                CONTACT
              </a>

              <a
                href="https://www.faber.co.uk/product/9781783352982-think-before-you-think/"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap"
              >
                UK
              </a>
            </div>

            <div>© 2026 Adrian Owen</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BooksFooter;
